/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
function useAsyncEffect(effect, inputs) {
    useEffect(function () {
        let mounted = true;
        const promise = effect(() => {
            return mounted;
        });
        Promise.resolve(promise).then((callback) => {
            if (callback) {
                callback === null || callback === void 0 ? void 0 : callback();
            }
        });
        return function () {
            mounted = false;
        };
    }, inputs !== null && inputs !== void 0 ? inputs : []);
}
export default useAsyncEffect;
//# sourceMappingURL=useAsyncEffect.js.map